import { render, staticRenderFns } from "./FieldType24.vue?vue&type=template&id=c6056570&scoped=true"
import script from "./FieldType24.vue?vue&type=script&lang=js"
export * from "./FieldType24.vue?vue&type=script&lang=js"
import style0 from "./FieldType24.vue?vue&type=style&index=0&id=c6056570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6056570",
  null
  
)

export default component.exports